import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";
class UserServiceService {
  static GetUserService(userServiceId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/userservice/userservice/${userServiceId}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static DeleteUserServices(userService) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/userservice/delete/${userService}`, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static GetUserServiceList(includeDeleted) {
    console.log("xx");
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .get(`${envConfig.apiBaseUrl}/api/userservice/userservicelist/${includeDeleted}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static GetDetailUserService(userService) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/userservice/detailuserservice/${userService}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static Update(userService) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    if (userService.defaultImageId === "") {
      userService.defaultImageId = null;
    }

    return axios
      .post(`${envConfig.apiBaseUrl}/api/userservice/update`, userService, config)
      .then((response) => {
        return ServiceHelper.ApiCallPostValidation(response, "update");
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static QuickCreate(userService) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    if (userService.defaultImageId === "") {
      userService.defaultImageId = null;
    }

    return axios
      .post(`${envConfig.apiBaseUrl}/api/userservice/quickcreate`, userService, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return response.data.data;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }
}

export default UserServiceService;
